import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { BsGraphUpArrow } from "react-icons/bs";

const Growth = () => {
    return (
        <BaseLayout>
            <div className="flex flex-col items-center justify-center w-full h-full gap-6">
                <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border br-1">
                    <BsGraphUpArrow className="text-4xl text-blue-400" />
                </div>
                <div className="text-center">
                    <h1 className="text-3xl font-bold p-text mb-2">Growth</h1>
                    <p className="text-lg s-text max-w-md">
                        Growth analytics and business metrics coming soon.
                    </p>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-1 border br-1">
                    <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse"></div>
                    <span className="text-sm s-text">Under Development</span>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Growth;
